import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";

@Component({
  selector: "inline-text-editor",
  template: `<span
    class="inline-text-editor"
    [froalaEditor]="_options"
    [(froalaModel)]="_value"
  >
  </span> `,
})
export class InlineTextEditorComponent {
  @Input() placeholderText: string;
  _options: Object = {
    key: "RB3J4B17C10iB6E5E4H5I2I3A6B6C5C4C-11NGNe1IODMGYNSFKV==",
    toolbarInline: true,
    charCounterCount: false,
    disableRightClick: true,
    shortcutsEnabled: [],
    shortcuts: false,
    pastePlain: true,
    multiLine: false,
    imagePaste: false,
    toolbarButtons: [],
    pluginsEnabled: [],
  };
  @Input() _value: string = "";
  @Output() valueChange = new EventEmitter();

  constructor() {
    this._options["placeholderText"] = this.placeholderText;
    this._options["events"] = {
      "froalaEditor.contentChanged": (e, editor) => {
        this.value = editor.html.get();
      },
    };
  }

  //get accessor
  @Input()
  get value(): string {
    return this._value;
  }

  //set accessor including call the onchange callback
  set value(v: string) {
    if (v !== this._value) {
      this._value = v;
      this.valueChange.emit(v);
    }
  }
}
